export default __webpack_public_path__ + "static/media/otherIcon.c86030ef.svg";